import request from "@/services/request"
import baseUrl from "@/services/baseUrl"

// let path =  `${baseUrl.main}/${baseUrl.envName != 'development'? "cs/": ''}cs/v1/`;
let path = `${baseUrl.main}/v1/`;
// path = `http://localhost:6050/v1/`;
let ucPath = `${baseUrl.main}/${baseUrl.envName != 'development' ? "uc/" : ''}v1/`;

// this is for globally used APIs only
export default {
  getPricings: (params = '') => request.get(path + "pricing/bo/list?limit=10&" + params, params),
  updatePricing: (params = {}) => request.put(path + "pricing/bo/update/" + params.pricingId, params),
  addPricing: (params = {}) => request.post(path + "pricing/bo/create", params),
  deletePricing: (params = '') => request.post(path + "pricing/bo/delete/" + params)
}